import * as React from 'react';
import { Grid, Button, IconButton, Typography } from '@mui/material';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import Divider from '@mui/material/Divider';
import InputAdornment from '@mui/material/InputAdornment';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import AccountCircle from '@mui/icons-material/AccountCircle';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import Visibility from '@mui/icons-material/Visibility';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import VpnKeyOutlinedIcon from '@mui/icons-material/VpnKey';
import Container from '@mui/material/Container';
import CopytRightIcon from '@mui/icons-material/Copyright';
import FacebookIcon from '@mui/icons-material/FacebookOutlined';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import IgIcon from '@mui/icons-material/Instagram';
import TwitterIcon from '@mui/icons-material/Twitter';
import YouTubeIcon from '@mui/icons-material/YouTube';
import { styled } from '@mui/material/styles';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import Login from './loginmain';
import Slider from './slider';
import Sislogo from './images/sislogoblue.png';
import Sislogo_ from './images/sislogo.png';
import Password from './forgottenpassword';

// Styled components for responsiveness
const ResponsiveContainer = styled('div')(({ theme }) => ({
  width: '100%',
  minHeight: '100vh',
  margin: 0,
  padding: 0,
  backgroundColor: 'white',
}));

const LeftPanel = styled(Grid)(({ theme }) => ({
  backgroundImage: "linear-gradient(315deg, #17dddd 0%, #1760d3 74%)",
  padding: theme.spacing(3),
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(2),
  },
  [theme.breakpoints.down('sm')]: {
    minHeight: '40vh',
  },
}));

const RightPanel = styled(Grid)(({ theme }) => ({
  padding: theme.spacing(3),
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(2),
  },
}));

const Logo = styled('img')(({ theme }) => ({
  width: '38%',
  maxWidth: '200px',
  [theme.breakpoints.down('sm')]: {
    width: '50%',
    margin: '0 auto',
    display: 'block',
  },
}));

const WelcomeText = styled(Typography)(({ theme }) => ({
  fontSize: '40px',
  background: "linear-gradient(315deg, #17dddd 0%, #1760d3 74%)",
  WebkitBackgroundClip: "text",
  WebkitTextFillColor: "transparent",
  textAlign: 'center',
  [theme.breakpoints.down('sm')]: {
    fontSize: '28px',
  },
}));

const SloganText = styled(Typography)(({ theme }) => ({
  background: "linear-gradient(315deg, #17dddd 0%, #1760d3 74%)",
  WebkitBackgroundClip: "text",
  WebkitTextFillColor: "transparent",
  textAlign: 'center',
  marginBottom: theme.spacing(2),
  [theme.breakpoints.down('sm')]: {
    fontSize: '14px',
  },
}));

const FooterText = styled(Typography)(({ theme }) => ({
  position: 'relative',
  textAlign: 'center',
  width: '100%',
  marginTop: theme.spacing(4),
  '& small': {
    background: "linear-gradient(315deg, #17dddd 0%, #1760d3 74%)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
  },
  '& a': {
    color: 'black',
    textDecoration: 'none',
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: '12px',
    marginTop: theme.spacing(2),
  },
}));

function Profile() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <ResponsiveContainer>
      <Grid container style={{textAlign:"center"}} sx={{ minHeight: '100vh', flexDirection: { xs: 'column', sm: 'row' } }}>
        

        <RightPanel 
          item 
          xs={12} 
          sm={5} 
          md={6} 
          lg={5}
          style={{textAlign:"center"}}
        >
          <WelcomeText variant="h1">WELCOME</WelcomeText>
          <SloganText variant="subtitle1">
            <b>The best school information system</b>
          </SloganText>

          <Box 
           style={{marginTop:"-19px"}}
          sx={{ 
            width: '100%', 
            maxWidth: '400px', 
            mt: { xs: 2, sm: '10%' }
          }}>
            <Login />
          </Box>

          <FooterText>
            <small>
              <b>Copyright SIS Revolution 2025</b>
              <br />
              <a href='https://www.ravinlead.sisrevolution.com'>
                Powered by RavinLead Tech Hub
              </a>
            </small>
          </FooterText>
        </RightPanel>
        <LeftPanel 
          item 
          xs={12} 
          sm={7} 
          md={6} 
          lg={7}
          style={{textAlign:"center"}}
        >
          <Box>
            <Logo src={Sislogo_} alt="SIS Logo" style={{textAlign:"center"}}  />
            <Typography 
              sx={{ 
                textAlign: 'center', 
                color: 'white', 
                mt: -2, 
                fontSize: { xs: 12, sm: 14 }
              }}
            >
              Harnessing Technology To Safeguard The Education System
            </Typography>
          </Box>
          <Box>
            <Slider />
          </Box>
        </LeftPanel>
      </Grid>
    </ResponsiveContainer>
  );
}

export default Profile;